export default window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
